// ID_TOKEN was a misnaming of the correct key, changing will invalidate
// sessions accross the app
const ACCESS_TOKEN_KEY = 'ID_TOKEN';
const ID_TOKEN_KEY = 'ID_TOKEN_V2';
export const getToken = () => {
    return window.localStorage.getItem(ACCESS_TOKEN_KEY);
};
export const saveToken = (token) => {
    if (!token)
        throw new Error('Saved Token needs a value');
    window.localStorage.setItem(ACCESS_TOKEN_KEY, token);
};
export const destroyToken = () => {
    window.localStorage.removeItem(ACCESS_TOKEN_KEY);
};
export const saveIdToken = (token) => {
    if (!token)
        throw new Error('Saved IdToken needs a value');
    window.localStorage.setItem(ID_TOKEN_KEY, token);
};
export const getIdToken = () => {
    return window.localStorage.getItem(ID_TOKEN_KEY);
};
export const destroyIdToken = () => {
    window.localStorage.removeItem(ID_TOKEN_KEY);
};
const jwtService = { getToken, saveToken, destroyToken, getIdToken, saveIdToken, destroyIdToken };
export default jwtService;
